import classNames from "classnames"

export default function Arrow({ className = "fill-current" }) {
  return (
    <svg
      role="img"
      aria-label="Pil"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}>
      <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" />
    </svg>
  )
}
